import makeStyles from '@mui/styles/makeStyles';
import { isDark } from '../../styles';

const useStyles = makeStyles((theme) => ({
  container: {
    position: 'relative',
    display: 'flex',
    flexDirection: (props) => (props.variant === 'passFail' ? 'row' : 'column'),
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
  },
  dropSelect: {
    position: 'absolute',
    zIndex: 100,
  },
  btn: {
    width: '100%',
    backgroundColor: theme.palette.action.disabledBackground,
    borderRadius: 10,
    borderLeftWidth: 5,
    borderColor: 'red',
    borderLeftStyle: 'solid',
    marginBottom: 1,
    textAlign: 'left',
    minHeight: 50,
    marginRight: (props) => (props.variant === 'passFail' ? 5 : 0),
    justifyContent: 'flex-start',
    fontWeight: 'normal',
    color: theme.palette.text.primary,
  },
  btnSelected: {},
  btnText: {
    fontWeight: 'normal',
    fontSize: 12,
  },
  optNumber: {
    fontWeight: 'bold',
    fontSize: 15,
    marginRight: 10,
  },
  icon: {
    marginRight: 5,
  },
  activeWrap: {
    border: '5px solid transparent',
    borderRadius: 10,
    boxShadow: "-5px 0px 0px 0px",
    margin: '9px 0',
    position: 'relative',

    '& .activetext': {
      position: 'absolute',
      color: theme.palette.text.primary,
      backgroundColor: theme.palette.background.default,
      top: -14,
      left: 16,
      fontSize: 12,
      padding: '0px 3px',
      '.right': {
        left: -36,
      }
    }
  }
}));

export default useStyles;
